//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddRess from "@/0/components/comForm/Address.vue";
import WechatPay from "@/components/comPay/comWechatPay";

export default {
  components: {
    "add-ress": AddRess,
    "wechat-pay": WechatPay
  },
  data() {
    return {
      tolPrize:0,//总金额
      numTolPrize:'',

      productData: {},
      value: "",
      showPicker: false,
      loading: false,
      ReceivingGoods: {},
      TotalData: {},
      step: 0,
      ConfigUrl: {
        GetIndexPaged: "mSmsApi/PassageNodeAddress/GetIndexPaged",
        Create: "mSmsApi/PassageNodeAddress/Create",
        Edit: "mSmsApi/PassageNodeAddress/Edit",
        Delete: "mSmsApi/PassageNodeAddress/Delete"
      }
    };
  },
  async created() {},
  async mounted() {
    await this.getData();
  },
  methods: {
    onConfirm(value) {
      this.value = value.Name;
      this.productData = value;
      this.showPicker = false;
    },
    StepClose(item) {
      this.step = 0;
      if (item) {
        var ReceivingGoods = this.ReceivingGoods;
        ReceivingGoods = {
          userName: item.Contact,
          telNumber: item.Mobile,
          detailInfo: item.FullAddress,
          OpenId: item.OpenId
        };
        this.ReceivingGoods = ReceivingGoods;
      }
    },
    async getData() {
      this.$msg.showLoading();
      let { data: result } = await this.$http({
        method: "post",
        url: "mSmsApi/UserGoodsBuyOrder/GetActivityInfo"
      });
      this.$msg.hideLoading();
      if (result.state == 1) {

        var res = result.data;
        this.TotalData = res;
        this.productData = res.GoodList[0];
        // this.tolPrize = (this.productData.Quantity)*(this.productData.Price)//总价计算
        this.tolPrize = res.TotalOrderAmount*100
        this.numTolPrize = res.TotalOrderAmount

        this.value = res.GoodList[0].Name;
        if (res.PassageNodeAddressOpenId) {
          var ReceivingGoods = this.ReceivingGoods;
          ReceivingGoods = {
            userName: res.MailUserName,
            telNumber: res.MailUserMobile,
            detailInfo: res.MailUserFullAddress
          };
          this.ReceivingGoods = ReceivingGoods;
        }
        return;
      }
      this.$msg.alert(result.msg);
    },
    SelectAddress() {
      this.step = 1;
    },
    async onSubmit() {
      this.$msg.confirm("确定提交订单?", async () => {
        var postData = {
          ActivityOpenId: this.TotalData.ActivityOpenId,
          UserAddressOpenId: this.ReceivingGoods.OpenId,
          GoodOpenId: this.productData.OpenId
        };
        this.$msg.showLoading();
        this.loading = true;
        let { data: result } = await this.$http({
          method: "post",
          url: "mSmsApi/UserGoodsBuyOrder/Create",
          data: postData
        });
        this.$msg.hideLoading();
        this.loading = false;
        console.log(result, "数据");
        if (result.state == 1) {
          this.startWechatPay(result);
          // this.$router.push(
          //   "/Mis/ShopUserGoodsActivityBuyOrder/End?OpenId=" +
          //     result.orderOpenId.OrderOpenId +
          //     "&OrderNo=" +
          //     result.orderOpenId.OrderNo +
          //     "&OrderOn=" +
          //     result.orderOpenId.OrderOn +
          //     "&OrderBy=" +
          //     result.orderOpenId.OrderBy
          // );
          return;
        }
        this.$msg.alert(result.msg);
      });
    },
    async startWechatPay(resultData) {
      // var wechatOpenId = this.$route.query.wechatOpenId;
      var OrderOpenId = resultData.orderOpenId.OrderOpenId;
      // if (!wechatOpenId) {
      //   this.$msg.alert("wechatOpenId参数不能为空.");
      //   return;
      // }
      // var url = "/mWechatApi/WechatPay/Pay";
      var url = "/mWechatApi/WechatPay/GetPayData";
      this.$msg.showLoading("正在支付...");
      var postData = {
        orderType: "99",
        orderOpenId: OrderOpenId
      };

      let { data: result } = await this.$http({
        method: "post",
        url: url,
        data: postData
      });
      this.$msg.hideLoading();
      console.log("WechatPay/Pay---result", result);

      if (result.state == 1) {
        this._createWechatPay(result, resultData);
        return;
      }
      this.$msg.alert(result.msg);
      console.log(result);
    },

    //微信支付
    _createWechatPay(result, resultData) {
      var data = result.data.PayData;
      var payData = {
        appId: data.AppId, //公众号名称，由商户传入
        timeStamp: data.Timestamp,
        nonceStr: data.NonceStr,
        package: data.Package,
        signType: data.SignType,
        paySign: data.PaySign //微信签名
      };
      WeixinJSBridge.invoke("getBrandWCPayRequest", payData, res => {
        console.log("getBrandWCPayRequest", res);
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          //支付成功
          //window.location.href = result.successUrl;
          // this.$msg.alert(result.successUrl);
          this.$router.push(
            "/Mis/ShopUserGoodsActivityBuyOrder/End?OpenId=" +
              resultData.orderOpenId.OrderOpenId +
              "&OrderNo=" +
              resultData.orderOpenId.OrderNo +
              "&OrderOn=" +
              resultData.orderOpenId.OrderOn +
              "&OrderBy=" +
              resultData.orderOpenId.OrderBy
          );
          return;
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          // 支付过程中用户取消

          this.$msg.alert("亲,您没有给我买单哦！", function() {});
          return;
        }
        this.$msg.alert(res.err_msg);
      });
    },
    alertObj(obj) {
      var output = "";
      for (var i in obj) {
        var property = obj[i];
        output += i + " = " + property + "\n";
      }
      alert(output);
    }
  }
};
